import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export type SpinnerSize = 'sm' | 'md' | 'lg';

const SIZE: Record<SpinnerSize, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-[3px]',
};

export interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: SpinnerSize;
  label?: string;
}

export const Spinner = forwardRef<HTMLDivElement, SpinnerProps>(function Spinner(
  { size = 'md', label = 'Carregando…', className, ...rest },
  ref,
) {
  return (
    <div ref={ref} role="status" className={cn('inline-flex', className)} {...rest}>
      <div
        className={cn(
          'animate-spin rounded-full border-yhelp-yellow border-t-transparent',
          SIZE[size],
        )}
        aria-hidden="true"
      />
      <span className="sr-only">{label}</span>
    </div>
  );
});
